import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { RecipientEntitiesService } from '@app/core/services/recipient-entities.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-recipient-entity-keywords',
  templateUrl: './recipient-entity-keywords.component.html',
  styleUrls: ['./recipient-entity-keywords.component.scss'],
})
export class RecipientEntityKeywordsComponent implements OnInit, OnDestroy {
  unsubscribe$: Subject<boolean> = new Subject<boolean>();
  keywords: string[];

  @ViewChild('newKeyword') newKeyword: any;

  constructor(
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<RecipientEntityKeywordsComponent>,
    private recipientEntitiesService: RecipientEntitiesService
  ) {}

  ngOnInit(): void {
    this.recipientEntitiesService
      .getMatchingIgnoreKeywords()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((keywords) => {
        this.keywords = keywords;
      });
  }

  onAdd(): void {
    const value: string = this.newKeyword.nativeElement.value.toString();
    this.newKeyword.nativeElement.value = '';
    if (!this.keywords.includes(value.toUpperCase())) {
      this.keywords.push(value.toUpperCase());
      this.keywords.sort();
    }
  }

  onDelete(keyword: string): void {
    this.keywords = this.keywords.filter((s) => s !== keyword);
    this.keywords.sort();
  }

  onSubmit(): void {
    this.recipientEntitiesService
      .updateMatchingIgnoreKeywords(this.keywords)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((_) => {
        this.close(true);
      });
  }

  close(isSuccess: boolean): void {
    this.dialogRef.close(isSuccess);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
  }
}
